import { render, staticRenderFns } from "./AddMusic.vue?vue&type=template&id=6254aa02"
import script from "./AddMusic.vue?vue&type=script&lang=js"
export * from "./AddMusic.vue?vue&type=script&lang=js"
import style0 from "./AddMusic.vue?vue&type=style&index=0&id=6254aa02&prod&lang=scss"
import style1 from "./AddMusic.vue?vue&type=style&index=1&id=6254aa02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports